import {Dayjs} from 'dayjs';
import {FileType} from '@features/files/types';
import {WellEntity} from '@features/wells/types';

export type DocumentType = FileType.FACT | FileType.PLAN | null;

export type FileEntity = {
    id: string;
    documentDate: string;
    uploadDate: string;
    fileSize: number;
    contentType: string;
    originalFilename: string;
    filename?: string;
    subgroupId?: string;
    wellId?: string;
    tags?: FileTag[];
    _links?: Record<string, {href: string; templated?: boolean}> & {
        self: {href: string};
        'Скачать файл': {href: string};
        'Удалить файл': {href: string};
    };
    type?: DocumentType | any;
    well?: WellEntity;
};

export type FilesCategoryType = {
    id: string;
    title: string;
    hasPlanFact: boolean;
};

export type FileTag = {
    id: string;
    title: string;
};

export type FileTagEntity = {
    id: string;
    title: string;
    wellId: string;
};

export type UsedFileTag = {
    isUsed: boolean;
    documentCount: number;
};

export type FileDataDialog = {
    file: File;
    filename: string;
    documentDate: Dayjs | null;
    tags: FileTag[];
    type: DocumentType;
};

export enum ReportType {
    PLAN = 'План',
    FACT = 'Факт',
}
